import { render } from "./ParcourSupPage.vue?vue&type=template&id=5f21cb78"
import script from "./ParcourSupPage.vue?vue&type=script&lang=js"
export * from "./ParcourSupPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__